import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      const pricingEl = document.getElementById('pricing');
      if (pricingEl) {
        const pricingRect = pricingEl.getBoundingClientRect();
        const pricingVisible = pricingRect.top < window.innerHeight && pricingRect.bottom > 0;
        setVisible(scrollY > heroHeight * 0.8 && !pricingVisible);
      } else {
        setVisible(scrollY > heroHeight * 0.8);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-99">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden" data-id="element-100">
          <div className="bg-[#0f172a]/95 backdrop-blur-md border-t border-[#334155] px-4 py-3 flex items-center justify-between gap-3" data-id="element-101">
            <div className="flex flex-col" data-id="element-102">
              <span className="text-white text-sm font-medium" data-id="element-103">
                Guion de 2AM
              </span>
              <span className="text-[#7fb3a0] text-xs" data-id="element-104">
                <span className="line-through text-[#94a3b8]" data-id="element-105">$19</span> $6.36 ·
                66% off
              </span>
            </div>
            <motion.button whileTap={{
          scale: 0.95
        }} onClick={() => {
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center gap-2 bg-[#e8856c] text-white px-5 py-2.5 rounded-lg text-sm font-bold shadow-[0_0_15px_rgba(232,133,108,0.3)] whitespace-nowrap cursor-pointer" data-id="element-106">
              <ShoppingBag className="w-4 h-4" data-id="element-107" />
              Comprar
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}